import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import { GetCognitoInfoQuery } from '@/API';
import store from '@/store/index';
import { RouterItem, LoginInfo, TenantLandscape } from '@/types/type';

type ICognitoInfo = GetCognitoInfoQuery['getCognitoInfo'];
export interface IPortalCommonStore {
  routerItems: RouterItem[];
  redirectPath: string | null;
  cognitoInfo?: ICognitoInfo;
  tenant: string;
  landscape: string;
  loginName: string;
}

@Module({
  dynamic: true,
  store,
  name: 'commonstore',
  namespaced: true,
  preserveState: localStorage.getItem('vuex') !== null,
})
export default class CommonStore extends VuexModule
  implements IPortalCommonStore {
  public routerItems: RouterItem[] = [];
  public redirectPath: string | null = null;
  public cognitoInfo = {} as ICognitoInfo;
  public tenant: string = '';
  public landscape: string = '';
  public loginName: string = '';
  public userAnonymousId: string = '';

  @Mutation
  public clear() {
    this.routerItems = [];
    this.redirectPath = null;
    this.cognitoInfo = {} as ICognitoInfo;
    this.tenant = '';
    this.landscape = '';
    this.loginName = '';
    this.userAnonymousId = '';
  }

  @Mutation
  public setRouterMenus(items: RouterItem[]) {
    this.routerItems = items;
  }

  public get routerMenus(): RouterItem[] {
    return this.routerItems;
  }

  @Mutation
  public setRedirectPath(path: string | null) {
    this.redirectPath = path;
  }

  @Mutation
  public setCognitoInfo(cognitoInfo: ICognitoInfo) {
    this.cognitoInfo = cognitoInfo;
  }

  @Mutation
  public setTenant(tenant: string) {
    this.tenant = tenant;
  }

  @Mutation
  public setLandscape(landscape: string) {
    this.landscape = landscape;
  }

  @Mutation
  public setLoginName(loginName: string) {
    this.loginName = loginName;
  }

  @Mutation
  public setUserAnonymousId(userAnonymousId: string) {
    this.userAnonymousId = userAnonymousId;
  }

  public get tenantLandscape(): TenantLandscape {
    return {
      tenant: this.tenant,
      landscape: this.landscape,
    };
  }

  public get loginInfo(): LoginInfo {
    return {
      tenant: this.tenant,
      landscape: this.landscape,
      loginName: this.loginName,
    };
  }
}

export const commonModule = getModule(CommonStore);
